import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createCompany(data) {
  return axiosInstance.post(`/signup`, formatRequest(data));
}

export function createlogin(data) {
  return axiosInstance.post(`/admin/login`, formatRequest(data));
}

//admin
export function getProfileDetails() {
  return axiosInstance.get(`/admin/get-profile`);
}

//store owner
export function getStoreOwnerProfileDetails() {
  return axiosInstance.get(`/store-owner-profile`);
}

//customer
export function getCustomerProfileDetails() {
  return axiosInstance.get(`/customer/profile`);
}

//admin
export function adminUpdateProfile(data) {
  return axiosInstance.post(`/admin/update-profile`, data);
}

//store owner
export function storeOwnerUpdateProfile(data) {
  return axiosInstance.post(`/store-owner-update-profile`, data);
}

//customer
export function customerProfileUpdateProfile(data) {
  return axiosInstance.post(`/customer/update-profile`, data);
}

//customer signup
export function customerSignup(data) {
  return axiosInstance.post(`/customer/signup`, formatRequest(data));
}

//change password
export function changePassword(data) {
  return axiosInstance.post(`/change-password`, formatRequest(data));
}

//otp
export function createSendOtp(data) {
  return axiosInstance.post(`/send-otp`, formatRequest(data));
}

//verify
export function verifyOtpLogin(data) {
  return axiosInstance.post(`/verify-otp-login`, formatRequest(data));
}

export function logout(data) {
  return axiosInstance.get(`/logout`);
}
